import { SecurityIdentifiersMap, SecurityResolutionRequest } from '@blk/wealth-web-endpoint';
import { IdentifiersMap } from '@ddt-web/domain';

import { SecurityIdentifiersMapRequest, SecurityResolutionDetailsRequest } from './security-details-request.model';

export const mapSecurityResolutionDetailsRequestToSecurityResolutionRequest = (securityResolutionDetailsRequest: SecurityResolutionDetailsRequest, useAladdinId: boolean = false) => {
	return {
		securities: securityResolutionDetailsRequest.securities
			? securityResolutionDetailsRequest.securities.map(securities => mapSecurityIdentifiersMapRequestToSecurityIdentifiersMap(securities, useAladdinId)) : []
	} as SecurityResolutionRequest;
};

export const mapSecurityIdentifiersMapRequestToSecurityIdentifiersMap = (securityIdentifiersMapRequest: SecurityIdentifiersMapRequest, useAladdinId: boolean = false) => {
	return {
		id: securityIdentifiersMapRequest.id,
		identifiers: mapIdentifiersToSecurityIdentifiers(securityIdentifiersMapRequest.identifiers, useAladdinId)
	} as SecurityIdentifiersMap;
};


export const mapIdentifiersToSecurityIdentifiers = (identifiersMap: IdentifiersMap, useAladdinId: boolean = false) => {
	const commonIds = {
		morningstarSecId: identifiersMap.morningstarSecId,
		clientId: identifiersMap.globalId,
		isin: identifiersMap.isin,
		sedol: identifiersMap.sedol,
		ticker: identifiersMap.ticker,
		modelId: identifiersMap.modelId
	};

	return useAladdinId ? {
		...commonIds,
		aladdinId: identifiersMap.aladdinId,
		cusip: identifiersMap.publicCusip || identifiersMap.cusip
	} : {
		...commonIds,
		cusip: identifiersMap.aladdinId || identifiersMap.publicCusip || identifiersMap.cusip
	};
};
